import React from "react";
import { FaPhoneAlt, FaEnvelope, FaClock } from "react-icons/fa";
import "./SupportHero.css";

const SupportHero = () => {
    return (
        <section className="_sHSec_1A_">
            <div className="_sHCont_2B_">
                <h1 className="_hTitle_3C_ _hTitle_s5E_">Need Help? Vanidya Support</h1>
                <p className="_hSubtitle_4D_">
                    Our support team is here for you — Customers, Sellers or Partners.
                    Reach out for order assistance, product questions, partnership support or feedback.
                    We’re committed to making your Vanidya experience smooth and worry-free.
                </p>
                <div className="_cIList_5E_">
          {/*<span className="_iItem_6F_">*/}
          {/*  <FaPhoneAlt className="_iIcon_7G_ phone-color" />*/}
          {/*  <b className="_iTxt_8H_">+91 99999 99999</b>*/}
          {/*</span>*/}
                    <span className="_iItem_6F_">
            <FaEnvelope className="_iIcon_7G_ email-color" />
            <b className="_iTxt_8H_">support@vanidya.com</b>
          </span>
          {/*          <span className="_iItem_6F_">*/}
          {/*  <FaClock className="_iIcon_7G_ clock-color" />*/}
          {/*  <span className="_iTxt_8H_">7am–11pm daily</span>*/}
          {/*</span>*/}
                </div>
            </div>
        </section>
    );
};

export default SupportHero;